import styled from 'styled-components';
import { LocalizedSectionTitle } from '@mews-commander/ui';
import { MEDIA_QUERY } from '@optimus-web/core';
import { getToken } from '@optimus-web/common';

export const LocalizedSectionTitleLarge = styled(LocalizedSectionTitle)`
    font-size: 2.5rem;
    line-height: ${getToken('lineHeight200')};

    ${MEDIA_QUERY.tabletUp} {
        font-size: 3rem;
    }
`;
